module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"validation":{"and":"and","at":"at"},"label":"Name","placeholder":"consultation","useCompanyNameLabel":"Use my business name instead of my personal name in the booking link and booking page.","sampleUrlPart":"consultation","apptTitle":"{apptTitle} with {host}","validationMessage":"There is already an appointment type with this name. Please choose a different name."}}')
  delete Component.options._Ctor
}
